<template>
  <div class="bind-wrapper">
  <div class="toast" v-show="toastShow">
        {{toastText}}
  </div>
    <div class="bind-title">{{title}}</div>
    <div class="bind-main">
      <div class="bind-item" :class="{'active-item': phoneFocus}">
            <span class="bind-item-title">
                国家/地区：
            </span>
        <select v-model="nationCode">
          <option value="86">+86</option>
          <option value="1">+1</option>
          <option value="61">+61</option>
          <option value="81">+81</option>
          <option value="7">+7</option>
          <option value="91">+91</option>
          <option value="82">+82</option>
          <option value="55">+55</option>
          <option value="27">+27</option>
          <option value="60">+60</option>
          <option value="65">+65</option>
          <option value="66">+66</option>
          <option value="62">+62</option>
          <option value="63">+63</option>
          <option value="64">+64</option>
          <option value="20">+20</option>
          <option value="234">+234</option>
          <option value="92">+92</option>
          <option value="98">+98</option>
          <option value="972">+972</option>
          <option value="853">+853</option>
          <option value="886">+886</option>
          <option value="852">+852</option>
          <!-- 添加其他国家/地区的选项 -->
        </select>
      </div>
        <div class="bind-item" :class="{'active-item': phoneFocus}">
            <span class="bind-item-title">
                手机号：
            </span>
            <input v-model="phone" class="bind-input" placeholder="请输入手机号" type="number" @focus="phoneFocus = true" @blur="checkPhone"/>
            <div class="error-text" v-show="phoneErrorText">{{phoneErrorText}}</div>
        </div>
        <div class="bind-item" :class="{'active-item': imageFocus}">
            <span class="bind-item-title">
                图文验证码：
            </span>
            <input class="bind-input image-input" v-model="imageCode" type="text" placeholder="请输入图文验证码" @focus="imageFocus = true" @blur="checkImageCode"/>
            <img v-if="imageSuccess" class="image-verify" :src="imageCodeUrl" @click="getImageCode"/>
            <div class="error-text" v-show="imageErrorText">{{imageErrorText}}</div>
        </div>
        <div class="bind-item" :class="{'active-item': verifyFocus}">
            <span class="bind-item-title">
                验证码:
            </span>
            <input class="bind-input image-input" type="number" v-model="verifyCode" @focus="verifyFocus = true" @blur="checkCode" maxlength="6"  placeholder="请输入手机验证码"/>
            <button class="verify-code" @click="getVerify">{{codeText}}</button>
           
            <div class="error-text" v-show="verifyErrorText">{{verifyErrorText}}</div>
        </div>
    </div>
    <div>
      <div class="bind-btn" @click="setBind">{{buttonText}}</div>
      <div class="tips">温馨提示：<br>如果你已入驻腾讯音乐人，请使用腾讯音乐人手机号验证，将自动为您绑定音乐学院账号</div>
    </div>
    
  </div>
</template>

<script>
import { getCookie } from '../common/common.js'
import { getVerifyCode,getImageCode,setBind,checkImageCode } from '../api/bind.js'
export default {
  data () {
    return {
      title:'',
      phone: '',
      phoneFocus: false,
      phoneErrorText: "",
      imageErrorText: '',
      verifyErrorText: '',
      verifyFocus:false,
      imageFocus: false,
      imageCodeUrl: '',
      imageKey: '',
      codeText: '获取验证码',
      isGetCode:true, //是否可从获取验证码
      isImageVerify: false, //默认false 校验是否图形验证码通过
      verifyCode: '', //短信验证码
      imageCode: '' ,//图文验证码
      nationCode: '86', //国家编号
      sessionKey:'',
      toastShow: false,
      toastText: '',
      type:'',
      buttonText:'',
      imageSuccess: false,
    }
  },
  created () {
    var queryData = this.$route.query
    console.log(queryData)
    this.sessionKey = queryData.session_key
    this.type = queryData.type
    if (!this.type) {
      this.title = "手机绑定"
      this.buttonText = "绑定"
      // this.$router.push({path:'bind',query:{session_key:this.sessionKey,type:login}});
    } else {
      this.title = "手机登录"
      this.buttonText = "登录"
    }
    this.getImageCode()
  },

watch: {
	'$route' (to, from) {
    // 路由发生变化页面刷新
	this.$router.go(0);
		}
},
  methods: {
    toast (str) {
        let v = this
        v.toastText = str
        v.toastShow = true
        setTimeout(function(){
          v.toastShow = false
        }, 1000)
      },
    /**
     *获取验证码
     */
    getVerify() {
        this.phoneErrorText= ""
        this.imageErrorText= ''
        this.verifyErrorText= ''
        let that = this;
        that.verifyFocus = false
        if(that.phone.length < 11) {
          //this.verifyErrorText= '请检查手机号是否正确'
          //return
        }
        if (!this.checkPhone()) {
          //return
        }
        if(!that.isImageVerify) {
          that.verifyErrorText = '请先输入图文验证码'
          return
        }
        if(!that.isGetCode) {
          return
        }
        //接口逻辑
        var postData = {
          mobile:that.phone,
          key:that.imageKey,
          captcha:that.imageCode,
          nation_code:that.nationCode
        }
        getVerifyCode(postData).then(res => { //获取验证码
          
          console.log(res)
          if(res.code == 422) {
            that.toast('验证码已失效或者错误')
            this.getImageCode()
            return
          } else if (res.code == 0) {
            that.toast("验证码已发送")
            let s = 60;
            let count = null;
            clearInterval(count);
            count = setInterval(()=>{
              that.codeText = `${s--}s`
              that.isGetCode =  false
              if(!s) {
                that.codeText = `重新获取`
                that.isGetCode =  true
                clearInterval(count);
              }
            },1000)
          } else {
            that.toast("验证码发送失败请稍后重试")
          }
        }).catch((err) => {
          console.log(err)
        })
        
    },
    /**
     * getImageCode 获取图片验证码
     */
    getImageCode() {
      this.phoneErrorText= ""
      this.imageErrorText= ''
      this.verifyErrorText= ''
      let that = this    
      //接口逻辑
      getImageCode().then(res => { 
          console.log(res)
          if (res.code == 0) {
            that.imageCodeUrl = res.data.img
            that.imageKey = res.data.key
            that.imageSuccess = true
          }
          
        }).catch((err) => {
          console.log(err)
        })
    },
    /**
     * setBind 绑定
     */
    setBind() {
      if(!this.phone) {
        this.phoneErrorText ="请先输入手机号"
        return
      } else if(!this.imageCode){
        this.imageErrorText ="请先输入图形验证码"
        return
      } else if(!this.verifyCode) {
        this.verifyErrorText ="请先输入短信验证码"
        return
      }
      let that = this  
      var postData = {
        mobile: that.phone,
        captcha: that.verifyCode,
        terminal:2,
        session_key:that.sessionKey
      }
      //接口逻辑
      setBind(postData).then(res => { 
        //这里做保存成功提示
        console.log(res)
        if (res.code != 0) {
          that.toast(res.message)
          setTimeout(function(){
            router.push('bind?session_key='+that.sessionKey);
          }, 1500)
        } else if (res.code == 0 && res.data.login_url) {
          window.location.href = res.data.login_url
        } else {
          that.toast(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    /**
     * checkImageCode 校验图形验证码是否头通过
     */
    checkImageCode() {
      this.phoneErrorText= ""
      this.imageErrorText= ''
      this.verifyErrorText= ''
      this.imageFocus = false
         //接口逻辑
      if (this.imageCode.length < 4) {
        this.imageErrorText= '请检查验证码是否正确'
        this.isImageVerify = false
      } else {
        this.isImageVerify = true
      }
    },
    /**
     * checkCode 校验短信验证码
     */
    checkCode() {
      this.phoneErrorText= ""
      this.imageErrorText= ''
      this.verifyErrorText= ''
      this.verifyFocus = false
    },
    /**
     * 检查手机号
     */
    checkPhone () {
      this.phoneErrorText= ""
      this.imageErrorText= ''
      this.verifyErrorText= ''
      this.phoneFocus = false
      if (!(/^[\d+*]{9,16}$/.test(this.phone)) && this.phone) {
        this.phoneErrorText = "请输入正确手机号"
        return false
      } else {
        return true
      }
    },
  },
  
}
</script>
<style lang="scss">
    .bind-wrapper {
        padding: 0.32rem;
        .bind-title {
            margin-bottom: 1rem;;
            font-size: 0.48rem;
            font-weight: 600;
            text-align: center;
        }
        .bind-main {
            display: flex;
            flex-direction: column;
        }
        .bind-item {
            position: relative;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            width: 100%;
            height: 0.88rem;
            border-bottom: 0.02rem solid #d4d9e2;
        }
        .active-item {
          border-color: #2a75ed;
        }
        .bind-item-title {
          flex-shrink: 0;
          width: 1.7rem;
          text-align: left;
          color: #666;
          font-size: 0.28rem;
        }
        .bind-input {
          height: 0.8rem;
          flex: 1;
          border: none;
          outline: none;
          box-shadow: none;
          font-size: 0.24rem;
          background-color: transparent;
        }
        .image-input {
          width: 1.6rem;
        }
        .image-verify {
          height: 0.8rem;
          width: 1.6rem;
        }
        .error-text {
          position: absolute;
          bottom: -0.5rem;
          left: 0;
          line-height: 0.5rem;
          color: #ec7259;
          font-size: 0.24rem;
        }
        .verify-code {
          outline:none;
          flex-shrink: 0;
          width: 1.6rem;
          height: 0.64rem;
          line-height: 0.64rem;
          border-radius: 0.08rem;
          border: 0.02rem solid #2a75ed;
          color: #2a75ed;
          font-size: 0.24rem;
          text-align: center;
          background-color: #fff;
          &:active {
            border-color: #5d8ced;
            color: #5d8ced;
          }
        }
        .bind-btn {
          margin-top: .8rem;
          width: 100%;
          height: 0.88rem;
          line-height: 0.88rem;
          background: #2a75ed;
          border-radius: 0.08rem;
          font-size: 0.32rem;
          color: #fff;
          text-align: center;
          letter-spacing: 0.07rem;
          &:active {
            background: #5d8ced;
          }
        }
    }

    .tips{
          margin-top: 0.2rem;
          line-height: 0.4rem;
          color: #bfbebe;
          font-size: 0.24rem;
        }

    .toast {
            position: fixed;
            z-index: 2000;
            left: 50%;
            top:10%;
            transition:all .2s;
            -webkit-transform: translateX(-50%) translateY(-50%);
               -moz-transform: translateX(-50%) translateY(-50%);
                -ms-transform: translateX(-50%) translateY(-50%);
                 -o-transform: translateX(-50%) translateY(-50%);
                    transform: translateX(-50%) translateY(-50%);
            text-align: center;
            border-radius: 0.06rem;
            color:rgb(253, 253, 253);
            background: rgba(17, 17, 17, 0.7);
            height: 0.6rem;
            line-height: 0.6rem;
            padding: 0 0.2rem;
            font-size: 0.15rem;
        }
    
</style>


// WEBPACK FOOTER //
// src/pages/bind.vue